import { bool, element, eventListener, expression, number, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const TabItemProperties = {
    active: {
        defaultValue: false,
        type: bool,
    },
    badge: {
        type: string,
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    icon: {
        type: oneOfType([string, element]),
    },
    index: {
        type: number,
    },
    label: {
        type: expression,
    },
    onClick: {
        type: eventListener,
    },
    onContextMenu: {
        type: eventListener,
    },
    onDoubleClick: {
        type: eventListener,
    },
    route: {
        type: string,
    },
    uppercase: {
        defaultValue: true,
        type: bool,
    },
    visible: {
        defaultValue: true,
        type: bool,
    },
};
export { TabItemProperties, };
//# sourceMappingURL=tab-item-types.js.map